import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="clipboard"
export default class extends Controller {
  static values = { data: String }

  copy(event) {
    event.preventDefault()
    navigator.clipboard.writeText(this.dataValue).then(() => {
      this.element.classList.add('clipboard--copied')
    })

    setTimeout(() => {
      this.element.classList.remove('clipboard--copied')
    }, 2000)
  }
}
